const masterTableFields = [
  {title: "Ref Id",
      is_searchable: false,
      class_name: 'w-110p',
      field: {
          name: "id"
      },
      fetch_key: "id"
  },
  {title: "Role",
      is_searchable: true,
      class_name: 'w-50p',
      field: {
          type: "select",
          name: "role_id"
      },
      fetch_key: "user_role"
  },
  {title: "Name",
      is_searchable: true,
      class_name: 'w-50p',
      field: {
          type: "text",
          name: "name"
      },
      fetch_key: "user.full_name"
  },
  {title: "Email",
      is_searchable: true,
      class_name: 'w-200p',
      field: {
          type: "text",
          name: "email"
      },
      fetch_key: "user.user_email.email"
  },
  {title: "Query",
      is_searchable: false,
      class_name: 'w-auto',
      field: {
          name: "message_query"
      },
      fetch_key: "message_query"
  },
  {title: "Created Date",
      is_searchable: false,
      class_name: 'w-125p',
      field: {
          name: "created_at"
      },
      fetch_key: "created_at"
  }
];
const fieldValuesReply = {
    contact_id: '',
    message   : '',
    message_text: ''
};
const fieldValidationReply = {
    contact_id: 'required',
    message_text: 'required|max:3000'
};

const data = {
  masterTableFields,
  fieldValuesReply,
  fieldValidationReply
};

export default data;